export default __webpack_public_path__ + "static/N0192-d16bb70bce54496dedeb5687014cd75e.png";